import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { inject } from 'vue';
export default {
  __name: 'BatchBannedWordCheck',
  setup(__props) {
    const context = inject('batchBannedWordCheck', null);
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _unref(context)?.visible.value ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        link: "",
        type: "primary",
        loading: _unref(context).loading.value,
        disabled: _unref(context).disabled.value,
        onClick: _unref(context).check
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(context).loading.value ? '检测中' : '重新检测违禁词'), 1)]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"])) : _createCommentVNode("", true);
    };
  }
};